/* AUTO-GENERATED from contracts/chat/errors.json. Do not hand-edit. */
import type { AthenaErrorIR } from "../ir.ts";

export const ATHENA_CHAT_ERROR_DESCRIPTORS: readonly AthenaErrorIR<string, "chat">[] =
	Object.freeze([
	  {
	    "code": "chat_auth_required",
	    "description": "The chat route requires an authenticated actor.",
	    "domain": "chat",
	    "errorNumber": 5000,
	    "kind": "validation",
	    "retry": "never",
	    "status": 401
	  },
	  {
	    "code": "chat_forbidden",
	    "description": "The actor is not allowed to perform the requested chat action.",
	    "domain": "chat",
	    "errorNumber": 5001,
	    "kind": "authorization",
	    "retry": "never",
	    "status": 403
	  },
	  {
	    "code": "chat_not_found",
	    "description": "The requested chat room, member, message, or related resource was not found.",
	    "domain": "chat",
	    "errorNumber": 5002,
	    "kind": "not_found",
	    "retry": "never",
	    "status": 404
	  },
	  {
	    "code": "chat_conflict",
	    "description": "The requested chat mutation conflicts with the current durable chat state.",
	    "domain": "chat",
	    "errorNumber": 5003,
	    "kind": "conflict",
	    "retry": "never",
	    "status": 409
	  },
	  {
	    "code": "chat_validation_failed",
	    "description": "The chat request payload failed validation.",
	    "domain": "chat",
	    "errorNumber": 5004,
	    "kind": "validation",
	    "retry": "never",
	    "status": 400
	  },
	  {
	    "code": "chat_unavailable",
	    "description": "Athena chat is temporarily unavailable.",
	    "domain": "chat",
	    "errorNumber": 5005,
	    "kind": "unavailable",
	    "retry": "safe",
	    "status": 503
	  },
	  {
	    "code": "chat_unsupported",
	    "description": "The requested chat operation is not supported by this Athena runtime.",
	    "domain": "chat",
	    "errorNumber": 5006,
	    "kind": "unsupported",
	    "retry": "never",
	    "status": 400
	  },
	  {
	    "code": "chat_internal",
	    "description": "Athena chat failed while processing the request.",
	    "domain": "chat",
	    "errorNumber": 5007,
	    "kind": "internal",
	    "retry": "never",
	    "status": 500
	  }
	]);
